module.exports = __webpack_public_path__ + "static/img/prizeBag.7da5150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prizeBag.png
// module id = Cli4
// module chunks = 128